import React, { createContext } from 'react';
import { CheckIcon } from '../../icons';
import { styled } from '../../themeCustomink';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var SelectCircle = styled('span')(function (_a) {
    var selected = _a.selected;
    return ({
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'grid',
        placeItems: 'center',
        width: '32px',
        height: '32px',
        borderRadius: '40px',
        cursor: 'pointer',
        backgroundColor: selected ? designTokens.color.blue.default.value : '#fff',
    });
});
export var ChipContainer = styled('span')({
    position: 'absolute',
    top: '16px',
    left: '16px',
});
export var SelectIcon = function (_a) {
    var selected = _a.selected, onSelect = _a.onSelect;
    var grey = designTokens.color.gray.disabled.value;
    return (React.createElement(SelectCircle, { onClick: onSelect, selected: selected },
        React.createElement(CheckIcon, { htmlColor: selected ? '#fff' : grey, fontSize: "small" })));
};
export var CardContext = createContext('medium');
//# sourceMappingURL=utils.js.map